/** @format */

import { IUser } from "./userType";

export interface IContributionPayload {
	unionId: string;
	memberId: string;
	contributionAmount: number;
	contributionPeriod: string;
	paymentMethodId: string;
}

export interface IContribution {
	_id: string;
	memberId: IUser;
	unionId: string;
	cycleId: string;
	contributionAmount: string;
	contributionDays: string[];
	contributionPeriod: string;
	status: string;
	paymentIntent: string;
	created_At: Date;
	updated_At: Date;
}

export enum ContributionStatus {
	Completed = "completed",
	Missed = "missed",
	Overdue = "overdue", //The user’s contribution window is still open, but they’re late. You might later convert this to "missed" if it passes a deadline.
	Pending = "pending",
	Failed = "failed",
}

export interface IContributionStatus {
	hasContributedToday: boolean;
	isMidCycleJoiner?: boolean;
	eligibleToContributeFrom?: string | null;
	canContributeYet?: boolean;
}

export interface IContributionCyclePayload {
	cycleStartDate: Date;
	payOutDate?: Date;
}

export interface IContributionCycle {
	unionId: string;
	startDate: Date;
	endDate: Date;
	payOutDate: Date;
	contributionsTotal: string;
	status: string;
	_id: string;
	createdAt: Date;
	updatedAt: Date;
	disbursedTo?: string;
	timezone?: string; // Timezone for contribution date calculations
}

export interface IContributionCycleByIdResult {
	cycle: IContributionCycle;
	contributions: IContribution[];
}

export interface IContributionDateStatus {
	date: string; // Expected date in "YYYY-MM-DD" format
	contributed: boolean;
	createdAt: Date;
	updatedAt: Date;
}

export interface IMemberStatus {
	member: IUser;
	contributionStatus: IContributionDateStatus[];
}

export interface IMemberContributionStatus {
	cycle: IContributionCycle;
	expectedDates: string[];
	memberStatuses: IMemberStatus[];
}
